import * as Api from '../api/tools';
import { pendingTask, begin, end, endAll } from 'react-redux-spinner';
import constants from '../constants'
import { bindActionCreators } from 'redux';
import _ from 'lodash'

export const sendOrderCallStart = () => ({
  type: constants.ACTIONS.SEND_ORDER_CALL_START,
  [pendingTask]: begin
});

export const sendOrderCallSucecss = () => ({
  type: constants.ACTIONS.SEND_ORDER_CALL_SUCCESS,
  [pendingTask]: end
});

export const sendOrderCallFailed = () => ({
  type: constants.ACTIONS.SEND_ORDER_CALL_FAILED,
  [pendingTask]: end
});

export const openWindow = () => ({
  type: constants.ACTIONS.OPEN_ORDER_CALL_WINDOW
});

export const closeWindow = () => ({
  type: constants.ACTIONS.CLOSE_ORDER_CALL_WINDOW
});

export const updateFormData = (changes) => ({
  type: constants.ACTIONS.UPDATE_ORDER_CALL_FORM_DATA,
  payload: changes
});

export const clearErrors = () => ({
  type: constants.ACTIONS.ORDER_CALL_CLEAR_ERRORS
});

export const addError = (error) => ({
  type: constants.ACTIONS.ORDER_CALL_ADD_ERROR,
  payload: error
});

export const removeError = (error) => ({
  type: constants.ACTIONS.ORDER_CALL_REMOVE_ERROR,
  payload: error
});

export const sendCallOrder = () => (dispatch, getState) => {
  dispatch(sendOrderCallStart());
  const { formData } = getState().orderCall;

  if (!formData.name.length) {
    dispatch(addError('name'));
  }

  if (formData.phone.length < 18) {
    dispatch(addError('phone'));
  }
  console.log(formData.phone.length);
  if (getState().orderCall.formErrors.length) {
    return;
  }

  return Api.ajax({
    url: constants.API.ROUTES.ORDER_CALL_PATH,
    method: 'POST',
    params: formData
  }).then(response => {
    dispatch(updateFormData({name: '', phone: ''}));
    dispatch(closeWindow());
    dispatch(clearErrors());
  }).catch(error => {
    throw(error);
  });
};



// WEBPACK FOOTER //
// ./app/javascript/app/actions/order_call_actions.js